<template>
  <RouterView />
</template>

<style>
body {
margin: 0;
}
</style>